import { createRoute, useNavigate } from "@tanstack/react-router";
import { FormEvent, useState } from "react";

import { useAuth } from "../auth/AuthContext";
import { useBrand } from "../brand/BrandContext";
import murrayAvatar from "../assets/murray-avatar-badge-180.png";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginScreen,
});

function LoginScreen() {
  const { login } = useAuth();
  const { brandName } = useBrand();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(username, password, remember);
      await navigate({ to: "/" });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#080b36] bg-[radial-gradient(circle_at_top_left,rgba(21,135,200,0.34),transparent_34rem),linear-gradient(180deg,#101552_0%,#070a2f_100%)] px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-xl border border-white/10 bg-white p-6 shadow-2xl">
        <div className="mb-6">
          <img
            alt="Murray"
            className="h-16 w-16 rounded-full border-2 border-blue-100 bg-white object-cover shadow-sm"
            src={murrayAvatar}
          />
          <h1 className="mt-4 text-2xl font-semibold text-[#11133f]">Murray Ops</h1>
          <p className="mt-1 text-sm text-slate-600">Sign in to {brandName || "your operations cockpit"}.</p>
        </div>
        <label className="block text-sm font-medium text-slate-700">
          Username
          <input
            className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm outline-none focus:border-[#1587c8]"
            autoComplete="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
        </label>
        <label className="mt-4 block text-sm font-medium text-slate-700">
          Password
          <input
            className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm outline-none focus:border-[#1587c8]"
            autoComplete="current-password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        <label className="mt-4 flex items-center gap-2 text-sm text-slate-600">
          <input type="checkbox" checked={remember} onChange={(event) => setRemember(event.target.checked)} />
          Remember this device for 30 days
        </label>
        {error ? <div className="mt-4 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div> : null}
        <button
          className="mt-5 w-full rounded-md bg-[#11133f] px-3 py-2 text-sm font-semibold text-white hover:bg-[#1587c8] disabled:opacity-60"
          disabled={busy}
          type="submit"
        >
          {busy ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </main>
  );
}
